// src/config/tabOrder.js
// Edit this array to change the tab order (developer only)
export const TAB_ORDER = [
  "3amigos",
  "Techbegin Products",
  "Btech Projects",
  "Smartphone",
  "Woodwork"
];
